import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="bg-dark text-white py-4 py-lg-5" style={{ backgroundColor: '#2a3f54' }}>
            <div className="container">
                {/* Main Content */}
                <div className="row align-items-start justify-content-between">
                    {/* About Section */}
                    <div className="col-lg-4 col-md-6 mb-4 mb-md-0">
                        <h5 className="text-uppercase mb-3 fw-bold" style={{ letterSpacing: '1px', fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
                            About Marcsri Homes
                        </h5>
                        <p className="text-light opacity-75" style={{ lineHeight: '1.6', fontSize: '0.9rem' }}>
                            Marcsri Homes offers shelter, compassion and a family to about 270 poor and abandoned across 10 homes all over the country.
                        </p>
                        <button
                            className="btn btn-outline-light btn-sm mt-2 text-uppercase"
                            style={{
                                borderRadius: '0',
                                padding: '6px 15px',
                                fontSize: '0.8rem',
                                transition: 'all 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#ffffff';
                                e.target.style.color = '#2a3f54';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.color = '#ffffff';
                            }}
                        >
                            Learn More
                        </button>
                    </div>

                    {/* Contact Section */}
                    <div className="col-lg-4 col-md-6 mb-4 mb-md-0">
                        <h5 className="text-uppercase mb-3 fw-bold" style={{ letterSpacing: '1px', fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
                            Contact Marcsri Homes
                        </h5>
                        <p className="text-light opacity-75" style={{ lineHeight: '1.6', fontSize: '0.9rem' }}>
                            Marc Sri Homes,<br />
                            No 26, St. Sebastian's Road,<br />
                            Katukurunda, Kalutara
                        </p>
                        <p className="text-light opacity-75 mb-1" style={{ fontSize: '0.9rem' }}>
                            <strong>Phone:</strong> +94 34 2223 363
                        </p>
                        <p className="text-light opacity-75" style={{ fontSize: '0.9rem' }}>
                            <strong>Email:</strong>{' '}
                            <a
                                href="mailto:marcsrihomes@gmail.com"
                                className="text-light hover-text-decoration-underline"
                                style={{
                                    textDecoration: 'none',
                                    transition: 'color 0.3s ease',
                                    fontSize: '0.9rem',
                                    wordBreak: 'break-all'
                                }}
                                onMouseEnter={(e) => (e.target.style.color = '#adb5bd')}
                                onMouseLeave={(e) => (e.target.style.color = '#d1d5db')}
                            >
                                marcsrihomes@gmail.com
                            </a>
                        </p>
                    </div>

                    {/* Social Media Icons - Now centered on mobile */}
                    <div className="col-lg-2 col-md-12 d-flex justify-content-md-end justify-content-center mt-md-0 mt-3">
                        <div className="d-flex gap-3">
                            <a
                                href="https://facebook.com"
                                className="text-light"
                                style={{ transition: 'transform 0.3s ease, color 0.3s ease' }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'scale(1.2)';
                                    e.target.style.color = '#adb5bd';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'scale(1)';
                                    e.target.style.color = '#ffffff';
                                }}
                            >
                                <FaFacebookF size={20} />
                            </a>
                            <a
                                href="https://instagram.com"
                                className="text-light"
                                style={{ transition: 'transform 0.3s ease, color 0.3s ease' }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'scale(1.2)';
                                    e.target.style.color = '#adb5bd';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'scale(1)';
                                    e.target.style.color = '#ffffff';
                                }}
                            >
                                <FaInstagram size={20} />
                            </a>
                            <a
                                href="https://whatsapp.com"
                                className="text-light"
                                style={{ transition: 'transform 0.3s ease, color 0.3s ease' }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'scale(1.2)';
                                    e.target.style.color = '#adb5bd';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'scale(1)';
                                    e.target.style.color = '#ffffff';
                                }}
                            >
                                <FaWhatsapp size={20} />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bottom Section - Stacked on mobile */}
                <div className="row mt-4 pt-3 border-top border-secondary">
                    <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
                        <p className="text-light opacity-75 mb-0" style={{ fontSize: '0.8rem' }}>
                            Copyright © 2025 - marcsri.com
                        </p>
                    </div>
                    <div className="col-md-6 text-center text-md-end">
                        <p className="text-light opacity-75 mb-0" style={{ fontSize: '0.8rem' }}>
                            Developed by{' '}
                            <span style={{ color: '#adb5bd', fontWeight: '500' }}>
                                Redev Solutions
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;